import Api from '@/api/api'
import configApi from '@/api/config/_api_config'

async function options(dossier = false) {
    // Short-lived capability stays in memory and is never put in a file URL.
    const response = await configApi().post(dossier ? '/medecin/tableau-access' : '/imagerie/access', {}, { med_access_scoped: true, timeout: 20000 })
    const token = response.data && response.data.data && response.data.data.access_token
    if (!token) throw new Error('Accès Imagerie indisponible.')
    return { med_access_scoped: true, timeout: 120000, headers: { [dossier ? 'X-Med-Access' : 'X-Imagerie-Access']: token } }
}
const base = (id, dossier = false) => '/imagerie/' + (dossier ? 'dossier/' : '') + 'examens/' + encodeURIComponent(id) + '/cliches'
export default {
    async list(id, dossier = false) { return (await Api().get(base(id, dossier), await options(dossier))).data.data },
    async upload(id, files, key) {
        const data = new FormData()
        data.append('upload_key', key)
        data.append('file_count', files.length)
        files.forEach(file => data.append('files[]', file))
        return (await Api().post(base(id), data, await options())).data.data
    },
    async remove(id, fileId, reason) {
        return (await Api().delete(base(id) + '/' + encodeURIComponent(fileId), { ...await options(), data: { reason } })).data.data
    },
    async content(id, fileId, dossier = false) {
        return Api().get(base(id, dossier) + '/' + encodeURIComponent(fileId) + '/contenu', { ...await options(dossier), responseType: 'blob' })
    }
}
